import Cookies, { CookieGetOptions, CookieSetOptions } from 'universal-cookie';

import { isLocalhost } from '../lib';

import { CookieKey } from './cookies-keys';

const defaultSetOptions: CookieSetOptions = {
  path: '/',
  secure: !isLocalhost,
  expires: new Date('2048-01-01T00:00:00.000Z'),
};

const defaultRemoveOptions: CookieSetOptions = {
  path: '/',
};

const cookies = new Cookies(null);

type CookieChangeCallback = (key: CookieKey, value: string | undefined) => void;
const changeListeners = new Set<CookieChangeCallback>();

const notifyListeners = (key: CookieKey, value: string | undefined) => {
  changeListeners.forEach((listener) => listener(key, value));
};

export const cookieUtils = {
  get(key: CookieKey, options?: CookieGetOptions) {
    return cookies.get(key, options);
  },

  set(key: CookieKey, value: string, options?: CookieSetOptions) {
    cookies.set(key, value, { ...defaultSetOptions, ...options });
    notifyListeners(key, value);
  },

  remove(key: CookieKey, options?: CookieSetOptions) {
    cookies.remove(key, { ...defaultRemoveOptions, ...options });
    notifyListeners(key, undefined);
  },

  getAll(options: CookieGetOptions) {
    return cookies.getAll(options);
  },

  subscribe(listener: CookieChangeCallback) {
    changeListeners.add(listener);
    return () => {
      changeListeners.delete(listener);
    };
  },
};
